import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListJenisAset } from "@/services/getData"

export default function MasterJenisAsetPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listJenisAset"],
    queryFn: getListJenisAset,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
